import { opened, closed } from '@/js/utils/modals/openedClosedModals';

export default class {
  constructor($c) {
    this.$c = $c.jquery ? $c.get(0) : $c;
    this.$moreLink = this.$c.querySelector('.js-more-link');
    this.$moreList = this.$c.querySelector('.js-more-list');
    this.$moreBox = this.$c.querySelector('.js-more-box');
    this.$moreClose = this.$c.querySelector('.js-more-close');
    this.closeType = this.$c.dataset.moreClose || 'body';
    this.trigger = this.$c.dataset.moreTrigger || 'click';

    if (this.$moreLink && this.$moreList) {
      this.$moreLink.addEventListener('click', (e) => {
        e.preventDefault();

        if (this.$moreList.classList.contains('_hidden')) {
          this.show();
        } else {
          this.hide();
        }
      });

      switch (this.closeType) {
        case 'body': {
          this.closeBody();

          break;
        }
        case 'close': {
          this.closeClose();

          break;
        }
        case 'all': {
          this.closeClose();
          this.closeBody();

          break;
        }
      }
    }
  }

  show() {
    opened();
    this.$moreList.classList.remove('_hidden');
    this.$moreLink.classList.add('_active');
    if (this.$moreBox) {
      this.$moreBox.classList.remove('_hidden');
    }
  }

  hide() {
    closed();
    this.$moreList.classList.add('_hidden');
    this.$moreLink.classList.remove('_active');
    if (this.$moreBox) {
      this.$moreBox.classList.add('_hidden');
    }
  }

  closeBody() {
    document.addEventListener('click', (e) => {
      if (!this.$moreList.classList.contains('_hidden')) {
        // если клик был не по нашему блоку и не по его дочерним элементам
        if (!this.$c.contains(e.target)) {
          this.hide();
        }
      }
    });
  }

  closeClose() {
    this.$moreClose.addEventListener('click', (e) => {
      e.preventDefault();

      this.hide();
    });
  }
}
